const actionTypes = {
  GET_INVOICE_ADDITIONS_LIST_LOADING: 'GET_INVOICE_ADDITIONS_LIST_LOADING',
  GET_INVOICE_ADDITIONS_LIST_SUCCESS: 'GET_INVOICE_ADDITIONS_LIST_SUCCESS',
  GET_INVOICE_ADDITIONS_LIST_FAILED: 'GET_INVOICE_ADDITIONS_LIST_FAILED',
  GET_INVOICE_ADDITIONS_LIST_REJECT: 'GET_INVOICE_ADDITIONS_LIST_REJECT',

  TOGGLE_INVOICE_ADDITION_STATUS_LOADING: 'TOGGLE_INVOICE_ADDITION_STATUS_LOADING',
  TOGGLE_INVOICE_ADDITION_STATUS_SUCCESS: 'TOGGLE_INVOICE_ADDITION_STATUS_SUCCESS',
  TOGGLE_INVOICE_ADDITION_STATUS_FAILED: 'TOGGLE_INVOICE_ADDITION_STATUS_FAILED',
  TOGGLE_INVOICE_ADDITION_STATUS_REJECT: 'TOGGLE_INVOICE_ADDITION_STATUS_REJECT',

  CREATE_INVOICE_ADDITION_LOADING: 'CREATE_INVOICE_ADDITION_LOADING',
  CREATE_INVOICE_ADDITION_SUCCESS: 'CREATE_INVOICE_ADDITION_SUCCESS',
  CREATE_INVOICE_ADDITION_FAILED: 'CREATE_INVOICE_ADDITION_FAILED',
  CREATE_INVOICE_ADDITION_REJECT: 'CREATE_INVOICE_ADDITION_REJECT',

  DELETE_INVOICE_ADDITION_LOADING: 'DELETE_INVOICE_ADDITION_LOADING',
  DELETE_INVOICE_ADDITION_SUCCESS: 'DELETE_INVOICE_ADDITION_SUCCESS',
  DELETE_INVOICE_ADDITION_FAILED: 'DELETE_INVOICE_ADDITION_FAILED',
  DELETE_INVOICE_ADDITION_REJECT: 'DELETE_INVOICE_ADDITION_REJECT',

  GET_DELETED_INVOICE_ADDITIONS_LIST_SUCCESS: 'GET_DELETED_INVOICE_ADDITIONS_LIST_SUCCESS',
  GET_DELETED_INVOICE_ADDITIONS_LIST_FAILED: 'GET_DELETED_INVOICE_ADDITIONS_LIST_FAILED',
  GET_DELETED_INVOICE_ADDITIONS_LIST_REJECT: 'GET_DELETED_INVOICE_ADDITIONS_LIST_REJECT',
  GET_DELETED_INVOICE_ADDITIONS_LIST_LOADING: 'GET_DELETED_INVOICE_ADDITIONS_LIST_LOADING'
};

export default actionTypes;
